module.exports = __webpack_public_path__ + "res/img/avatar_female_grey.cd2f1167.png";